import Barba from 'barba.js'
import VideoCarousel from "../Classes/VideoCarousel";

export default Barba.BaseView.extend({
    namespace: 'video',
    onEnter() {
        this.carousels = [];
        document.querySelectorAll( '.video-row' ).forEach( el => this.carousels.push( new VideoCarousel( el ) ) )
    },
    onEnterCompleted() {
    },
    onLeave() {
        this.carousels.forEach( carousel => carousel.destroy() );
        this.carousels = null;
    },
    onLeaveCompleted() {
    }
})